import React from "react";
import firebase from "../../helper/firebase";

import Head from '../../components/Head'
import JobCardHeader from "../../components/JobCardHeader";
import UnpublishedJob from "../../components/UnpublishedJob";
import EmptyState from "../../components/EmptyState";
import ApplicantTabs from "../../components/ApplicantTabs";
import LoggedOutCard from "../../components/LoggedOutCard";
import SkeletonCard from "../../components/SkeletonCard";
import UnauthorizedText from "../../components/UnauthorizedText";
import {Title} from '../../helper/consts'

import { Card, CircularProgress, Divider } from "material-ui";

import Fade from "material-ui/transitions/Fade";


const style = {
  loading: {
    alignSelf: "center",
    width: "75px",
    height: "75px",
    marginTop: "calc(50vh - 37.5px - 64px)"
  }
};

export default class Applicants extends React.Component {
  // constructor(props){
  //   super(props);
  //
  //   this.state = {
  //     loggedIn:this.props.loggedIn,
  //   }
  // }
  componentDidMount() {
    // firebase.auth().onAuthStateChanged(user=>{
    //   if(user){
        this.props.actions.getSelectionStages();
        this.props.actions.getApplicants(this.props.match.params.jid);
        this.props.actions.getJobListener(this.props.match.params.jid);
    //   }
    //   else{
    //     this.setState({loggedIn:false})
    //   }
    // })
  }

  // static getDerivedStateFromProps(nextProps,state){
  //   if(!!nextProps.loggedIn && !state.loggedIn){return {loggedIn:true}}
  //   if(!nextProps.loggedIn && !!state.loggedIn){return {loggedIn:false}}
  //   if(!!nextProps.loggedIn &&
  //     !!nextProps.admin &&
  //     !!nextProps.selectionStagesLoading &&
  //     !!nextProps.actions){
  //       console.log('selectionStagesLoading');
  //       nextProps.actions.getSelectionStages();
  //       return null
  //     }
  //   // if(!!nextProps.loggedIn &&
  //   //   !!nextProps.admin &&
  //   //   !!nextProps.applicantsLoading &&
  //   //   !!nextProps.actions){
  //   //     console.log('applicantsLoading');
  //   //     nextProps.actions.getApplicants(nextProps.match.params.jid);
  //   //     return null
  //   //   }
  //   if(!!nextProps.loggedIn &&
  //     !!nextProps.admin &&
  //     !nextProps.jobs[nextProps.match.params.jid] &&
  //     !!nextProps.actions) {
  //     console.log('jobs[nextProps.match.params.jid]');
  //     nextProps.actions.getJobListener(nextProps.match.params.jid);
  //     return null
  //   }
  //   else{return null}
  // }

  componentWillUnmount() {
    var unsubscribe = firebase
      .firestore()
      .collection("jobs")
      .doc(this.props.match.params.jid)
      .onSnapshot(function() {});
    unsubscribe();
  }

  renderJob = () => {
    const job = this.props.jobs[this.props.match.params.jid];
    if (!job) return;
    let html = [];
    let card = (
      <Fade key={job.jid} in={true}>
        <Card className="card">
          <JobCardHeader job={job} />
          {job.status !== "published" && (
            <Divider light />
          )}
          {job.status !== "published" && (
            <UnpublishedJob status={job.status} />
          )}
        </Card>
      </Fade>
    );
    html.push(card);
    return html;
  };

  render() {
    return (
      <React.Fragment>
        <Head title={`Applicants | ${Title}`} />
        <div id={this.props.loggedIn ? "loggedInBody" : null} className="body">
          {this.props.authLoading && (
            <CircularProgress style={style.loading} size={75} />
          )}
          {this.props.loggedIn &&
            !this.props.adminLoading &&
            this.props.admin &&
            !this.props.jobs[this.props.match.params.jid] && (
              <SkeletonCard header={true} />
            )}
          {!!this.props.loggedIn &&
            !this.props.adminLoading &&
            !!this.props.admin &&
            !!this.props.jobs[this.props.match.params.jid] &&
            this.renderJob()}

          {this.props.loggedIn &&
            !this.props.adminLoading &&
            this.props.admin &&
            (!this.props.jobs[this.props.match.params.jid] ||
              this.props.selectionStagesLoading ||
              this.props.applicantsLoading) && (
              <SkeletonCard header={true} content={true} actions={true} />
            )}
          {this.props.loggedIn &&
            !this.props.adminLoading &&
            this.props.admin &&
            !!this.props.jobs[this.props.match.params.jid] &&
            !this.props.selectionStagesLoading &&
            !this.props.applicantsLoading &&
            !!this.props.applicants[this.props.match.params.jid] && (
              <ApplicantTabs
                uid={this.props.uid}
                stages={this.props.selectionStages}
                job={this.props.jobs[this.props.match.params.jid]}
                jid={this.props.match.params.jid}
                applicants={this.props.applicants[this.props.match.params.jid]}
              />
            )}
          {this.props.loggedIn &&
            !this.props.adminLoading &&
            this.props.admin &&
            !!this.props.jobs[this.props.match.params.jid] &&
            !this.props.selectionStagesLoading &&
            !this.props.applicantsLoading &&
            !this.props.applicants[this.props.match.params.jid] && (
              <EmptyState
                key="no applicants"
                subject={"No Applicants"}
                message={"Share your Ad to receiving applicants."}
                btnDestination={"/Jobs"}
                btnMsg={"Back to Jobs"}
              />
            )}

          {!this.props.authLoading &&
            this.props.loggedIn &&
            !this.props.adminLoading &&
            !this.props.admin && (
              <div className="unauthorizedTextContainer">
                <UnauthorizedText
                  text="Unauthorized"
                  subText="Access is limited"
                />
              </div>
            )}

          {!this.props.authLoading && !this.props.loggedIn && <LoggedOutCard />}
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Applicants/Applicants.js